module.exports = __webpack_public_path__ + "img/1.9f6e87e6.jpg";